import { z } from 'zod';
import { projectDetailUrlTypeEnum } from './report';

/// ////////////////////////////////////////
/// Enum
/// ////////////////////////////////////////

export const reportInvestmentFundCsvHeader = z.enum([
  'fundSheetNumber',
  'ministryName',
  'fundOwner',
  'projectName',
  'startYear',
  'endYear',
  'accumulatedInvestmentsFromTheGovernment',
  'investmentAmount2YearsBefore',
  'investmentAmount1YearBefore',
  'investmentAmountCurrentYear',
  'accumulatedInvestmentFromPrivateSectors',
  'businessForm',
  'investmentDecision2YearsBeforeCount',
  'investmentDecision2YearsBeforeAmount',
  'investmentExecution2YearsBeforeCount',
  'investmentExecution2YearsBeforeAmount',
  'investmentDecision1YearBeforeCount',
  'investmentDecision1YearBeforeAmount',
  'investmentExecution1YearBeforeCount',
  'investmentExecution1YearBeforeAmount',
  'investmentDecisionCurrentYearCount',
  'investmentDecisionCurrentYearAmount',
  'investmentExecutionCurrentYearCount',
  'investmentExecutionCurrentYearAmount',
  'overview',
  'projectDetailPageUrl',
]);

/// ////////////////////////////////////////
/// Model
/// ////////////////////////////////////////

export const ReportFundBusinessElementModel = z.object({
  businessForm: z.string(),
  // 支援等決定額
  investmentDecisionAmount1YearBefore: z.number().nullable(),
  investmentDecisionAmount2YearsBefore: z.number().nullable(),
  investmentDecisionAmountCurrentYear: z.number().nullable(),
  investmentDecisionCount1YearBefore: z.number().nullable(),
  investmentDecisionCount2YearsBefore: z.number().nullable(),
  investmentDecisionCountCurrentYear: z.number().nullable(),
  negativeInvestmentDecisionAmount1YearBeforeCount: z.number().nullable(),
  negativeInvestmentDecisionAmount2YearsBeforeCount: z.number().nullable(),
  negativeInvestmentDecisionAmountCurrentYearCount: z.number().nullable(),
  rawInvestmentDecisionAmount1YearBefore: z.number().nullable(),
  rawInvestmentDecisionAmount2YearsBefore: z.number().nullable(),
  rawInvestmentDecisionAmountCurrentYear: z.number().nullable(),
  // 支援等実行額
  investmentExecutionAmount1YearBefore: z.number().nullable(),
  investmentExecutionAmount2YearsBefore: z.number().nullable(),
  investmentExecutionAmountCurrentYear: z.number().nullable(),
  investmentExecutionCount1YearBefore: z.number().nullable(),
  investmentExecutionCount2YearsBefore: z.number().nullable(),
  investmentExecutionCountCurrentYear: z.number().nullable(),
  negativeInvestmentExecutionAmount1YearBeforeCount: z.number().nullable(),
  negativeInvestmentExecutionAmount2YearsBeforeCount: z.number().nullable(),
  negativeInvestmentExecutionAmountCurrentYearCount: z.number().nullable(),
  rawInvestmentExecutionAmount1YearBefore: z.number().nullable(),
  rawInvestmentExecutionAmount2YearsBefore: z.number().nullable(),
  rawInvestmentExecutionAmountCurrentYear: z.number().nullable(),
});

export const ReportFundInvestmentModel = z.object({
  fundSheetNumber: z.number(),
  ministryName: z.string(),
  fundSheetBranchNumber: z.number().nullable(),
  fundOwner: z.string().nullable(),
  projectName: z.string(),
  startYear: z.number().nullable(),
  endYear: z.number().nullable(),
  accumulatedInvestmentsFromTheGovernment: z.number().nullable(),
  rawAccumulatedInvestmentsFromTheGovernment: z.number().nullable(),
  negativeAccumulatedInvestmentsFromTheGovernmentCount: z.number().nullable(),
  accumulatedInvestmentsFromTheGovernmentAccountingTypeNames: z
    .string()
    .array(),
  investmentAmount2YearsBefore: z.number().nullable(),
  rawInvestmentAmount2YearsBefore: z.number().nullable(),
  investmentAmount1YearBefore: z.number().nullable(),
  rawInvestmentAmount1YearBefore: z.number().nullable(),
  investmentAmountCurrentYear: z.number().nullable(),
  rawInvestmentAmountCurrentYear: z.number().nullable(),
  accumulatedInvestmentFromPrivateSectors: z.number().nullable(),
  rawAccumulatedInvestmentFromPrivateSectors: z.number().nullable(),
  fundBusinesses: ReportFundBusinessElementModel.array(),
  overview: z.string().nullable(),
  id: z.string(),
});
export const ReportInvestmentFundsModel = z.object({
  data: ReportFundInvestmentModel.array(),
  organizations: z.object({ id: z.string().uuid(), name: z.string() }).array(),
});
export const ReportInvestmentFundsParamsModel = z.object({
  isAllOrganization: z.boolean().nullish(),
  fiscalYear: z.any().transform((v) => Number(v)),
  projectDetailUrlType: projectDetailUrlTypeEnum,
});

/// ////////////////////////////////////////
/// Schema
/// ////////////////////////////////////////

export const ReportInvestmentFundsFilterSchema = z.object({
  fiscalYear: z.any().transform((v) => Number(v)),
  organizationIds: z
    .union([z.literal('all'), z.string().uuid()])
    .array()
    .min(1),
  projectDetailUrlType: projectDetailUrlTypeEnum,
});
